import axios from "axios";

function info({ loc, contents, qrcode = false }) {
  // if (window.location.href.includes("testing") || qrcode)
  //   axios.post(
  //     "https://tswap.aigehui028.com/api/v2/logging",
  //     JSON.stringify({
  //       content: {
  //         loc,
  //         contents
  //       }
  //     })
  //   );
}

export default {
  info
};



// WEBPACK FOOTER //
// ./src/lib/log.js